import AccountSettingsOpeningDateUpdatePage from "@faire/prototype-playground/workspace/az/account-settings-opening-date-update";
import IdvOpeningDateFreshnessUpdatePage from "@faire/prototype-playground/workspace/az/idv-opening-date-freshness-update";
import OwFRevampPage from "@faire/prototype-playground/workspace/az/owf-revamp";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const OpeningSoonOnBrandPortalPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/az/opening-soon-on-brand-portal/Page")
);

export function AndyZhenRoutes() {
  return (
    <Switch>
      <Route
        path="/az/account-settings-opening-date-update"
        component={AccountSettingsOpeningDateUpdatePage}
      />
      <Route
        path="/az/idv-opening-date-freshness-update"
        component={IdvOpeningDateFreshnessUpdatePage}
      />
      <Route
        path="/az/opening-soon-on-brand-portal"
        component={OpeningSoonOnBrandPortalPage}
      />
      <Route path="/az/owf-revamp" component={OwFRevampPage} />
    </Switch>
  );
}

export const slug = "az";
